import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import React, { useContext, useState, useEffect } from "react";
import EditorJs from "../../Components/Editor";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";
import { useCookies } from "react-cookie";
import Loader from "../../Components/Loader";

function SubscriptionDetailRelation({
  userSubscriptions,
  toggleModalShowFile,
  toggleModalAdd,
  setFile,
  setFileSettings,
  setshowModalModify,
  isOperator,
}) {
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies();
  const apiToken = useContext(TokenContext);
  const [dettaglio, setDettaglio] = useState();
  const [fileB64, setFileB64] = useState(false);
  const [showModalFile, setShowModalFile] = useState(false);
  const [firstTime, setFirstTime] = useState(true);

  const handleSave = (azione) => {
    setLoading(true);
    userSubscriptions.dettagli = dettaglio;
    Repo.postInsertDettaglio(apiToken, azione, userSubscriptions)
      .then((response) => {
        if (response.data) {
          setFileB64(response.data);
          setShowModalFile(true);
          setLoading(false);
        } else window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={fileB64 ? `data:application/pdf;base64,${fileB64}` : undefined}
        type="application/pdf"
      ></object>
    );
  };

  const handleCloseModalFile = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (firstTime && userSubscriptions?.dettagli) {
      setDettaglio(userSubscriptions.dettagli);
    } else {
      setDettaglio(`
<p style="text-align:center;">UFFICIO SERVIZI SOCIALI</p>
<p><strong>Oggetto:</strong></p>
<p><strong>Servizio proponente: </strong>Servizio Sociale Professionale di Ambito operante nel Comune di ${cookies.user_profile.AreaName}.</p>
<p><strong>Analisi della situazione</strong></p>
<p><strong>Obiettivo generale</strong></p>
<p><strong>Obiettivi specifici</strong></p>
<p><strong>Metodologia</strong></p>
<p><strong>Soggetti pubblici e privati</strong></p>
<p><strong>Verifica dei risultati</strong></p>
<p><strong>Modalità di espletamento del Servizio</strong></p>
<p><strong>Tempi</strong></p>
<p style="text-align:right;">${cookies.user_profile.AreaName},</p>
<p style="text-align:right;">Assistente Sociale</p>
`);
    }
    setFirstTime(false);
  }, [userSubscriptions]);

  return (
    <>
      <div className="row no_print">
        <div className="col-lg-12 mt-3">
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body">
                <h4>Relazione</h4>

                {isOperator ? (
                  <>
                    {userSubscriptions?.state === "ADDED" && (
                      <div className="alert alert-info mt-2">
                        In attesa della compilazione della relazione e della
                        firma da parte dell’utente, a cura dell’operatore
                        comunale.
                      </div>
                    )}
                    {userSubscriptions?.state === "LOADED" && (
                      <div className="row align-items-center justify-content-center">
                        <button
                          type="button"
                          className="btn btn-primary text-success w-50 p-2 py-3 mb-4"
                          onClick={() => {
                            setshowModalModify(true);
                          }}
                        >
                          <svg className="icon icon-white">
                            <use href={`${iconSprite}#it-pencil`} />
                          </svg>{" "}
                          <span className="align-middle text-white">
                            Esito Valutazione
                          </span>
                        </button>
                      </div>
                    )}
                    {userSubscriptions?.state === "VALIDATED" && (
                      <div className="alert alert-success mt-2">
                        <div className="row">
                          <strong>Validato</strong>
                          {userSubscriptions?.nProtocolloUscita && (
                            <div className="col-3">
                              N. Protocollo Uscita:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocolloUscita}
                              </strong>
                            </div>
                          )}
                          <div className="col text-right">
                            <button
                              type="button"
                              className="btn btn-outline-primary text-success  p-2"
                              onClick={() => {
                                setshowModalModify(true);
                              }}
                              title="Modifica iscrizione"
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-pencil`} />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {" "}
                    {userSubscriptions?.state === "ADDED" && (
                      <div className="alert alert-info mt-2">
                        Per procedere con la revisione dell'iscrizione, è
                        necessario redigere una relazione utilizzando l’editor
                        di testo, quindi scaricarla e farla sottoscrivere
                        dall’utente.
                      </div>
                    )}{" "}
                    {userSubscriptions?.state === "LOADED" && (
                      <div className="alert alert-info mt-2">
                        In Attesa di revisione da parte dell'ufficio di piano
                      </div>
                    )}
                    {userSubscriptions?.state === "VALIDATED" && (
                      <div className="alert alert-success mt-2">
                        <div className="row">
                          <strong>Validato</strong>
                          {userSubscriptions?.nProtocolloUscita && (
                            <div className="col-3">
                              N. Protocollo Uscita:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocolloUscita}
                              </strong>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="container mb-5">
                  <div className="row">
                    <div className="col-lg-12">
                      {" "}
                      <div className="container mb-5">
                        <div className="row row-cols-2">
                          {userSubscriptions &&
                            userSubscriptions.subscriptionFiles.filter(
                              (x) => x.description === "fileDaFirmare",
                            ).length > 0 &&
                            userSubscriptions.subscriptionFiles
                              .filter((x) => x.description === "fileDaFirmare")
                              .map((allegato, index) => (
                                <>
                                  <div className="col border-right" key={index}>
                                    <div className="categoryicon-top">
                                      <span className="text">
                                        <a
                                          href="#"
                                          className="text-decoration-none font-weight-bold"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setFile({
                                              data:
                                                "data:application/pdf;base64," +
                                                allegato?.storageFile?.file,
                                            });
                                            toggleModalShowFile(true);
                                          }}
                                        >
                                          <svg className="icon">
                                            <use
                                              href={`${iconSprite}#it-clip`}
                                            ></use>
                                          </svg>
                                          {allegato.storageFile.name}
                                        </a>

                                        <br />
                                      </span>
                                    </div>

                                    <p className="card-text font-serif">
                                      {allegato.description ===
                                      "fileDaFirmare" ? (
                                        <>Atto da firmare</>
                                      ) : (
                                        <></>
                                      )}
                                    </p>
                                  </div>
                                  {userSubscriptions.subscriptionFiles.filter(
                                    (x) => x.description === "fileFirmato",
                                  ).length > 0 ? (
                                    <>
                                      {userSubscriptions.subscriptionFiles
                                        .filter(
                                          (x) =>
                                            x.description === "fileFirmato",
                                        )
                                        .map((allegatoFirmato, index) => (
                                          <div className="col" key={index}>
                                            <div className="row">
                                              <div className="col-11">
                                                <div className="categoryicon-top">
                                                  <span className="text">
                                                    <a
                                                      href="#"
                                                      className="text-decoration-none font-weight-bold"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        setFile({
                                                          data:
                                                            "data:application/pdf;base64," +
                                                            allegatoFirmato
                                                              ?.storageFile
                                                              ?.file,
                                                        });
                                                        toggleModalShowFile(
                                                          true,
                                                        );
                                                      }}
                                                    >
                                                      <svg className="icon">
                                                        <use
                                                          href={`${iconSprite}#it-clip`}
                                                        ></use>
                                                      </svg>
                                                      {
                                                        allegatoFirmato
                                                          .storageFile.name
                                                      }
                                                    </a>

                                                    <br />
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="col-1">
                                                <button
                                                  type="button"
                                                  className={
                                                    userSubscriptions?.state ===
                                                    "VALIDATED"
                                                      ? "border btn btn-outline-primary text-success  p-2"
                                                      : "btn btn-outline-primary text-success  p-2"
                                                  }
                                                  onClick={() => {
                                                    toggleModalAdd(true);
                                                    setFileSettings({
                                                      title: "Atto Firmato",
                                                      description:
                                                        "fileFirmato",
                                                      fileName: "Atto_Firmato",
                                                    });
                                                  }}
                                                  aria-label="Carica atto firmato"
                                                  disabled={
                                                    userSubscriptions?.state ===
                                                    "VALIDATED"
                                                  }
                                                  title={
                                                    userSubscriptions?.state ===
                                                    "VALIDATED"
                                                      ? "Non si possono apportare modifiche alle iscrizioni validate"
                                                      : "Sovrascrivi atto firmato"
                                                  }
                                                >
                                                  <svg className="icon icon-primary">
                                                    <use
                                                      href={`${iconSprite}#it-upload`}
                                                    />
                                                  </svg>
                                                </button>
                                              </div>
                                            </div>

                                            <p className="card-text font-serif ms-1">
                                              {allegatoFirmato.description ===
                                              "fileFirmato" ? (
                                                <>Atto Firmato</>
                                              ) : (
                                                <>
                                                  {allegatoFirmato.description}
                                                </>
                                              )}
                                            </p>
                                          </div>
                                        ))}
                                    </>
                                  ) : (
                                    <div className="col align-self-center text-center">
                                      <button
                                        type="button"
                                        className={
                                          userSubscriptions?.state ===
                                          "VALIDATED"
                                            ? "border btn btn-outline-primary text-success  p-2"
                                            : "btn btn-outline-primary text-success  p-2"
                                        }
                                        onClick={() => {
                                          toggleModalAdd(true);
                                          setFileSettings({
                                            title: "Atto Firmato",
                                            description: "fileFirmato",
                                            fileName: "Atto_Firmato",
                                          });
                                        }}
                                        disabled={
                                          userSubscriptions?.state ===
                                          "VALIDATED"
                                        }
                                        title={
                                          userSubscriptions?.state ===
                                          "VALIDATED"
                                            ? "Non si possono apportare modifiche alle iscrizioni validate"
                                            : "Carica atto firmato"
                                        }
                                      >
                                        <svg className="icon icon-primary">
                                          <use
                                            href={`${iconSprite}#it-upload`}
                                          />
                                        </svg>{" "}
                                        <span className="align-middle">
                                          Carica atto firmato
                                        </span>
                                      </button>
                                    </div>
                                  )}
                                </>
                              ))}
                        </div>
                      </div>
                      <div className="wrapper">
                        {!firstTime && (
                          <EditorJs
                            editorTemp={dettaglio}
                            setEditorTemp={setDettaglio}
                          />
                        )}
                      </div>{" "}
                      <div className="row mt-4">
                        <div className="col-6">
                          {!userSubscriptions.subscriptionFiles.filter(
                            (x) => x.description === "fileDaFirmare",
                          ).length > 0 && (
                            <div className="alert alert-warning col-12">
                              Relazione non ancora ufficializzata
                            </div>
                          )}
                        </div>
                        <div className="col-6 d-flex justify-content-end mb-4">
                          <button
                            type="button"
                            className="btn btn-outline-primary mr-2"
                            onClick={() => handleSave("0")}
                          >
                            <svg className="icon icon-secondary mr-1">
                              <use href={`${iconSprite}#it-pencil`} />
                            </svg>
                            Salva bozza
                          </button>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => handleSave("1")}
                          >
                            <svg className="icon icon-white mr-1">
                              <use href={`${iconSprite}#it-file`} />
                            </svg>
                            Ufficializza e crea PDF
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent
        toggleModal={setShowModalFile}
        isOpen={showModalFile}
        header="Crea PDF Relazione"
        body={bodyFile()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalFile}
      />
      {loading && <Loader />}
    </>
  );
}

export default SubscriptionDetailRelation;
